import { Controller } from "@hotwired/stimulus"

// Admin form preview: intercept the previewed form's submit so it never posts
// (nothing is ever saved) and pop up a transient notice saying so. Mounted on a
// wrapper in the form_preview layout; the submit event bubbles up from the
// previewed form to this controller's element, ahead of Turbo's document-level
// bubble handler, so preventDefault stops both the native submit and Turbo.
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.notify("Form submitted — but this is a preview, so no data was saved.")
  }

  notify(message) {
    this.element.querySelector("[data-preview-notice]")?.remove()

    const notice = document.createElement("div")
    notice.dataset.previewNotice = ""
    notice.setAttribute("role", "status")
    notice.setAttribute("aria-live", "polite")
    notice.className =
      "fixed inset-x-0 bottom-6 z-50 mx-auto w-fit max-w-md rounded-lg bg-gray-900 px-4 py-3 text-center text-sm font-medium text-white shadow-lg transition-all duration-300 opacity-0 translate-y-2"
    notice.textContent = message
    this.element.appendChild(notice)

    requestAnimationFrame(() => notice.classList.remove("opacity-0", "translate-y-2"))

    setTimeout(() => {
      notice.classList.add("opacity-0", "translate-y-2")
      setTimeout(() => notice.remove(), 300)
    }, 3500)
  }
}
